/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { UUID } from 'io-ts-types/lib/UUID';
import { DxpTenantRegionCode } from '../../DxpTenant/DxpTenant.entity.enum';
import { ConsoleInstanceStatusCode, ConsoleInstanceType } from './ConsoleBaseInstance.entity.enum';

export type EntityConsoleBaseInstance = io.TypeOf<typeof ConsoleBaseInstance>;

export const ConsoleBaseInstance = io.type({
  createdAt: io.number,
  instanceId: UUID,
  isLinked: io.boolean,
  isSandbox: io.boolean,
  name: io.string,
  organisationId: io.string,
  region: io.keyof(DxpTenantRegionCode),
  status: io.type({
    code: io.keyof(ConsoleInstanceStatusCode),
    message: io.string,
  }),
  tenantId: UUID,
  type: io.keyof(ConsoleInstanceType),
  updatedAt: io.number,
  version: io.string,
});
